import React from 'react'
import ReactDOM from 'react-dom'
import LoanCalculatorContainer from 'modules/react/loan-calculator/LoanCalculatorContainer'
import Modal from 'modules/react/loan-calculator/Modal'
import OpenModalButton from 'modules/react/loan-calculator/content/OpenModalButton'

export default function LoanCalculator (props) {
  return (
    <LoanCalculatorContainer {...props}>
      {ReactDOM.createPortal(
        <OpenModalButton modalButtonText={props.modalButtonText}/>,
        document.querySelector('.mtt-single-car-cover .button-section')
      )}
      <Modal/>
    </LoanCalculatorContainer>
  )
}
